<template>
  <div class="dashboard-body">
    <div class="row">
      <sidenav class="custom-col-width-2" />
      <div class="custom-col-width-10">
        <navbar />
        <div class="content-section">
          <adminDashboard v-if="isAdmin" />
          <employeeDashboard v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidenav from '@/components/Sidenav.vue';
import navbar from '@/components/Navbar.vue';
import adminDashboard from '@/components/dashboard/Admin_Dashboard.vue';
import employeeDashboard from '@/components/dashboard/Employee_Dashboard.vue';
import { GET_ORGANIZATION } from '@/store/action_types';
import { SET_ACCOUNT_ORGANIZATION } from '@/store/mutation_types';
import { isAdminRole } from '@/utils/roles';

export default {
  title: 'Dashboard',
  components: {
    sidenav,
    navbar,
    adminDashboard,
    employeeDashboard,
  },
  computed: {
    account() {
      return this.$store.getters.account.data;
    },
    isAdmin() {
      return isAdminRole(this.account?.role);
    },
  },
  methods: {
    refreshOrganization() {
      if (!this.account?.organizationId) return;
      this.$store.dispatch(GET_ORGANIZATION, { id: this.account.organizationId }).then((res) => {
        if (res) {
          const org = this.$store.getters.organization.data;
          if (org) {
            this.$store.commit(SET_ACCOUNT_ORGANIZATION, org);
          }
        }
      });
    },
  },
  mounted() {
    this.refreshOrganization();
  },
};
</script>

<style scoped>
.custom-col-width-2 {
  width: 16.66%;
}

.custom-col-width-10 {
  width: 83.3%;
}

@media (max-width: 1000px) {
  .custom-col-width-2 {
    width: 14%;
  }

  .custom-col-width-10 {
    width: 86%;
  }
}
</style>
